module.exports = "<div class=\"y-tooltip-ctn\" data-bind=\"style:style,visible:show,transferdom,css:cssPosition\">\n  <div class=\"y-tooltip-arrow\">\n  </div>\n  <div class=\"y-tooltip-cover\"></div>\n  <div class=\"y-tooltip-ctn-inner\" data-bind=\"ref:setRef\">\n    <span data-bind=\"text:title\"></span>\n    <!-- ko template: { nodes: $componentTemplateNodes} --><!-- /ko -->\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/tooltipctn/index.html
// module id = 493
// module chunks = 0